/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const VERIFY_CUSTOMER_ACCOUNT = gql`
  mutation verifyCustomerAccount($token: String!, $password: String) {
    verifyCustomerAccount(token: $token, password: $password) {
      ... on CurrentUser {
        id
        identifier
        __typename
      }

      ... on ErrorResult {
        errorCode
        message
        __typename
      }
      __typename
    }
  }
`;
